export enum OsOnboardingListRequiredStepIds {
  EditProfile = 'edit-profile',
  DesignCard = 'design-card',
  CreateRoom = 'create-room',
  CustomizeDesktop = 'customize-desktop',
  InviteFriends = 'invite-friends',
}
